/* eslint-disable max-len */
import React, { Fragment, useState } from 'react'
import Pagination from '../../../../../components/Pagination'
import { formatAdjustedDate } from '../../../../../CommonMethods/formatDate';
import { useNavigate } from 'react-router-dom';
import AnimatedList from '../../../../../components/Animation/AnimatedList';
const Table = ({promotedStudentsList,
    searchParams, 
    setSearchParams, 
    setPageLoading, 
    promotedStudentsCount}) => {

    const navigate = useNavigate();

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    const handleResize = () => {
        setScreenWidth(window.innerWidth);
    };     

    // Attach event listener when the component renders
    window.addEventListener('resize', handleResize);
    /**
     * The function `handleOnClickPageNumber` updates the search parameters with a new page number and sets
     * the page loading state to true.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setPageLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }
    return(
        <div class="-mx-1">
            <div class="overflow-auto scroll-bar px-2 pb-[62px] mb-3" id="search-result">
                <div class="display" data-testid="promote-table">
                    <table aria-label="Outside Table" class="w-full noPadding auto-layout" id="admin-table">
                        <thead>
                            <tr class="pb-2.5 mx-auto mt-5 border-transparent">
                                <th class="" colspan="4">
                                    <span class="flex items-center justify-center ">Current Class
                                    </span>
                                </th>
                                <th class="" colspan="4">
                                    <span class="flex items-center justify-center ">Promoted to
                                    </span>
                                </th>
                                <th class="" colspan="4">
                                    <span class="flex items-end justify-end ">Action
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr id='secondHeader'>
                                <td class="min-w-[140px] font-semibold">
                                    <span >AY
                                    </span>
                                </td>
                                <td class="min-w-[110px] font-semibold">
                                    <span >Class
                                    </span>
                                </td>
                                <td class="min-w-[110px] font-semibold">
                                    <span >Section
                                    </span>
                                </td>
                                <td class="min-w-[140px] font-semibold ">
                                    <span class="flex items-center justify-end"># of Students
                                    </span>
                                </td>
                                <td class="min-w-[140px] border-l border-[#EDEDED] font-semibold">
                                    <span class="flex items-center justify-start ">AY
                                    </span>
                                </td>
                                <td class="min-w-[110px] font-semibold">
                                    <span >Class
                                    </span>
                                </td>
                                <td class="min-w-[110px] font-semibold">
                                    <span >Section
                                    </span>
                                </td>
                                <td class="2xl:w-[170px] md:min-w-[130px] font-semibold">
                                    <span class="flex items-center justify-end text-right"># of Students Promoted
                                    </span>
                                </td>
                                <td class="2xl:w-[180px] md:min-w-[140px] border-l border-[#EDEDED] font-semibold">
                                    <span class="flex items-center justify-end text-right "># of Students not Promoted
                                    </span>
                                </td>
                                <td class="min-w-[140px] font-semibold ">
                                    <span >Promoted on
                                    </span>
                                </td>
                                <td class="pr-5 min-w-[140px] rounded-tr-[16px] rounded-br-[16px] font-semibold border-r border-[#EDEDED]" >
                                    <span >Promoted by
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                        <tbody>
                            {promotedStudentsList?.map((history) => (
                                <AnimatedList
                                    key={history._id}
                                    keyItem={history._id}
                                    title="View Promotion Details"
                                    handleClick={(e) => {
                                        if (e.target.classList.contains('prevent-click')) {
                                            return;
                                        }
                                        navigate(`/student-master/promote-history/promotion-details/${history?._id}?${searchParams.toString()}`);
                                    }}
                                    child={
                                        <>
                                            <td className="min-w-[180px] text-start cursor-pointer">{history?.current_class?.academic_year_name}</td>
                                            <td className="text-start cursor-pointer">{history?.current_class?.class_name}</td>
                                            <td className="text-start cursor-pointer">{history?.current_class?.section_name}</td>
                                            <td className="text-end cursor-pointer">{history?.total_students_count}</td>
                                            <td className="text-start border-l border-[#EDEDED] cursor-pointer">{history?.promoted_class?.academic_year_name}</td>
                                            <td className="text-start cursor-pointer">{history?.promoted_class?.class_name}</td>
                                            <td className="text-start cursor-pointer">{history?.promoted_class?.section_name}</td>
                                            <td className="text-end cursor-pointer">{history?.promoted_students_count}</td>
                                            <td className="text-end border-l cursor-pointer border-[#EDEDED]">{history?.not_promoted_students_count}</td>
                                            <td className="text-start cursor-pointer">{formatAdjustedDate(history?.promoted_on)}</td>
                                            <td className="text-start cursor-pointer">{history?.promoted_by}</td>
                                            <td className="text-[#031624] cursor-pointer text-start border-l border-t border-[#EDEDED] prevent-click">
                                                <div className='flex justify-center items-center'>
                                                    <button 
                                                        id='view_grn_details_btn' 
                                                        className='list-actn-btn prevent-click'
                                                        onClick={() => navigate(`/student-master/promote-history/promotion-details/${history?._id}?${searchParams.toString()}`)}
                                                    >
                                                        View
                                                    </button>
                                                </div>
                                            </td>
                                        </>
                                    }
                                />
                            ))}
                        </tbody>
                        {promotedStudentsCount === 0 && (
                            <tbody>
                                <tr>
                                    <td style={{ 'line-height': '100px', 'text-align': 'start', 'padding-left': '500px'}} colspan="14" className="no-records-message" id='no-matching-result'>
                                        {'No records found.'}
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
            {promotedStudentsCount > 10 && <Pagination
                TotalCount={promotedStudentsCount}
                totalPageNumber={Math?.ceil(promotedStudentsCount / 10)}
                selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                handleOnClickPageNumber={handleOnClickPageNumber}
            />}
        </div>
    )
}
export default Table;   






